<h1>User Management</h1>

<app-search-input
    #search
    placeholder="Search users and guests"
    (search)="onSearch($event)"
    (inputChange)="onInputChange($event)"
    [noSearchView]="true"
>
</app-search-input>

<mat-action-list>
    @for (user of users; track user.id) {
        <mat-list-item (click)="openUser(user)">
            <app-avatar matListItemAvatar 
                 [src]="user.connections.discord?.avatar || 'assets/img/avatars/default.webp'" 
                 [alt]="user.connections.vrchat?.username || user.username"></app-avatar>
            <span matListItemTitle>
                @if (user.type === 'guest') {
                    <em>Guest</em> {{ user.username }}
                } @else {
                    {{ user.username }}
                }
            </span>
            <span matListItemLine>{{ user.connections.vrchat?.username }}</span>
            <span matListItemLine>{{ user.connections.patreon?.username }} - <span [style.color]="getUserSubscriptionTier(user).color">{{ getUserSubscriptionTier(user).name }}</span></span>
            <button mat-icon-button 
                    [routerLink]="['/admin/support', user.id]" 
                    (click)="$event.stopPropagation()"
                    matTooltip="View Support Page"
                    matListItemMeta>
                <mat-icon>support</mat-icon>
            </button>
        </mat-list-item>
        <mat-divider></mat-divider>
    }
</mat-action-list>

<div #loadMoreButton>
    <button mat-button  [disabled]="isLoading || !hasMoreData" (click)="loadMore()">
        @if (!hasMoreData) {
            No more users
        } @else {
            @if (isLoading) {
                <mat-progress-spinner mode="indeterminate" diameter="20"></mat-progress-spinner>
            } @else {
                Load More
            }
        }
    </button>
</div>
